// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__gXp3h","title":"Images45_title__1RNxw","images":"Images45_images__39IfX"};